export default "__VITE_ASSET__CHG2Cxbe__";